import React from 'react';
import AutomationHero from './automationHero/AutomationHero';
import AutomationService from './automationService/AutomationService';
import AutomationTestimonial from './automationTestimonial/AutomationTestimonial';
import AutomationSecure from './automationSecure/AutomationSecure';
import AutomationDiverse from './automationDiverse/AutomationDiverse';
import AutomationBenefit from './automationBenefit/AutomationBenefit';
import AutomationSource from './automationSource/AutomationSource';
import AutomationEnd from './automationEnd/AutomationEnd';

export default function Automation() {
  return (
    <div>
        <AutomationHero/>
        <AutomationEnd/>
        <AutomationSource/>
        <AutomationBenefit/>
        <AutomationDiverse/>
        <AutomationSecure/>
        <AutomationTestimonial/>     
        <AutomationService/>
    </div>
  )
}
